export default "__VITE_ASSET__CAvscvCA__"